import { REGEX_EMAIL } from '@/configuration/regexConf';

export default function validation(contact, messagesErreur) {
  if (!contact.nom
  || contact.nom === undefined) {
    messagesErreur.push({
      message: 'editionContact.name',
    });
  }
  if (contact.accesPortail && (!contact.email
    || contact.email === undefined)) {
    messagesErreur.push({
      message: 'editionContact.email',
    });
  }
  if ((contact.email
    && contact.email !== undefined)
    && !REGEX_EMAIL.test(contact.email.toLowerCase())) {
    messagesErreur.push({
      message: 'general.emailFormatError',
    });
  }
  if (contact.accesPortail && contact.utilisateur.motPasse !== undefined
    && contact.utilisateur.motPasse?.length
    && contact.utilisateur.motPasse !== contact.utilisateur.motPasseConf) {
    messagesErreur.push({
      message: 'editionContact.messages.motDePasseDifferent',
    });
  }
  return messagesErreur.length > 0;
}
